<template>
  <div class="register-page-block">
    <SPreloader />
    <SLandingTopBar />

    <div class="header-spacer--standard"></div>

    <div class="md-layout separete-content slide-left">
      <div class="md-layout-item">
        <md-content
          class="page-content all-content"
          :class="[{ 'increase-page-content': hasError }]"
        >
          <md-content
            class="center-content"
            :class="[
              { 'increase-center-content': hasError },
              { 'md-elevation-5': animationHighlight },
            ]"
          >
            <div>
              <SRegistrationForm
                ref="registrationForm"
                class="register-form"
                @register="showModal"
                @hasError="hasError = true"
                @noError="hasError = false"
                :redirectTo="redirectTo"
              />
            </div>
          </md-content>
        </md-content>
        <div class="go-back-content">
          <p>Already have an account?&nbsp;</p>
          <a @click="backAction">{{ backButtonText }}</a>
        </div>
      </div>
    </div>
    <Footer/>
    <Modal
      id="register"
      buttonName="CLOSE"
      v-if="confirmRegistration || response"
      ref="modal"
      :title="getModalTitle"
      @button="closeModal"
      :materialButton="true"
    >
      <footer
        data-cy="lpRegistrationResponse"
        v-if="theResponse"
        class="h5 font-weight-normal register-response"
      >
        <h4>{{ responseTitle }}</h4>
        <span v-html="theResponse" />
        <span v-if="responseFooter && !emailResend">
          <strong>Didn't receive the email?</strong>
          Please check your spam folder, or click
          <a class="resend-email-link" @click="resendEmail">resend</a>
          and we'll send it again.
        </span>
        <span
          v-html="emailResend"
          class="the-email-resend"
          v-if="emailResend"
        ></span>
      </footer>
      <LoadingSpinner position="relative" v-else />
      <div slot="afterButton">
        <span>
          <p>
            <a class="contact-us" @click="contactUs">Contact</a>
            to report a problem or suggestion
          </p>
        </span>
      </div>
    </Modal>
    <CookiesAndPrivacy v-if="!storageCookies" @cookies-privacy="accept" />
  </div>
</template>

<script>
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import SPreloader from "@/components/organisms/SPreloader.vue";
import SRegistrationForm from "@/material-components/molecules/SRegistrationForm.vue";
import UserHelperVue from "../mixins/UserHelper.vue";
import { mapGetters } from "vuex";
import Modal from "@/components/atoms/Modal.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import CookiesAndPrivacy from "@/components/molecules/CookiesAndPrivacy";
import Footer from "@/templates/Footer";

export default {
  name: "RegisterPage",
  mixins: [UserHelperVue],
  data() {
    return {
      cookiesPrivacy: localStorage.getItem("cookies_privacy"),
      backButtonText: "Log in",
      emailResend: null,
      hasError: false,
      animationHighlight: false,
      redirectTo: null,
    };
  },
  components: {
    SLandingTopBar,
    SPreloader,
    SRegistrationForm,
    Modal,
    LoadingSpinner,
    CookiesAndPrivacy,
    Footer,
  },
  computed: {
    ...mapGetters({
      confirmRegistration: "getSuccessNotification",
      response: "getRegistrationErrorResponse",
    }),
    storageCookies() {
      return this.cookiesPrivacy;
    },
    responseTitle() {
      if (this.response.error) return "Register error";
      else if (
        this.response &&
        this.response.result === "Registration successful"
      ) {
        return "Please check your email";
      } else if (this.response.result === "Email already taken")
        return "Please provide another email";
      else if (this.response.result === "Username already taken")
        return "Please provide another username";
      return this.response.result;
    },
    theResponse() {
      if (this.response.error) {
        return this.response.error;
      } else if (
        this.response &&
        this.response.result === "Registration successful"
      ) {
        return "Your account has been created. Please check your email and follow the instructions to activate your account.<br/> <br/>";
      }
      return this.response.result;
    },
    responseFooter() {
      return (this.response && this.response.result === "Registration successful")
    },
    getModalTitle() {
      if (this.response.result === "Email already taken") return "Email error";
      else if (this.response.result === "Username already taken")
        return "Username error";
      else if (this.response.result === "Registration successful")
        return "Registration successful!";
      else if (this.response.error) return "Registration Error";
      return "Registration successful!";
    },
  },
  methods: {
    accept(a) {
      this.cookiesPrivacy = a;
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },
    showModal() {
      $("#register").modal("show");
    },
    resendEmail() {
      if (this.$refs.registrationForm.credentials.email !== undefined) {
        this.resendActivation({
          email: this.$refs.registrationForm.credentials.email,
          token: this.response.token,
        });
        this.emailResend = "<br/><strong>Email successfully resent<strong/>";
      }
    },
    contactUs() {
      this.$router.push({
        path: "/contact-us",
        query: {redirect: this.redirectTo},
      });
      this.$refs.modal.closeModal();
    },
    backAction() {
      if (this.redirectTo) {
        this.$router.push({
          path: "/login-redirect",
          query: { redirect: this.redirectTo },
        });
      } else this.$router.push("/login");
    },
  },
  created() {
    if (this.$route.query.redirect)
      this.redirectTo = this.$route.query.redirect;
  },
  mounted() {
    setTimeout(() => {
      this.animationHighlight = true;
    }, 201);
  },
};
</script>

<style lang="scss" scoped>
.all-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-content {
  height: 37.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: $light;
}
.center-content {
  width: 29.67rem;
  height: 47.5rem;
  margin-bottom: 12em;
  background: $white;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 4px;
  transition: all 0.86s ease;
  /* transform: scale(0.1, 0.1); */
}
.md-elevation-5 {
  transform: scale(1, 1);
}
.go-back-content {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 1.25px;
  width: 100%;
  display: inline-flex;
  justify-content: center;
}
.go-back-content p {
  font-size: 14px;
  color: #8d8c8c !important;
}
.go-back-content a {
  color: $request !important;
  text-decoration: none !important;
  cursor: pointer;
}
.register-form {
  width: 85%;
  transform: translateX(8.2%);
}
</style>

<style lang="scss" scoped>
.register-page-block {
  background-color: #f4f4f4 !important;
}
.separete-content {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column !important;
  margin-top: 80px;
}
.increase-page-content {
  height: 42.125rem;
}
.increase-center-content {
  height: 52rem;
}
@media screen and (max-width: 425px) {
  .center-content {
    width: 90vw;
  }
}
@media screen and (max-width: 768px) {
  .separete-content {
    margin-top: 160px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .separete-content {
    margin-top: 150px;
  }
}
@media screen and (min-width: 1024px) {
  .separete-content {
    margin-top: 98px;
  }
  .go-back-content {
    margin-top: 0;
  }
}
@media screen and (min-width: 1200px) {
  .center-content {
    height: 40rem;
  }
  .page-content {
    height: 32.125rem;
  }
  .separete-content {
    margin-top: 92px;
  }
  .increase-center-content {
    height: 44rem;
  }
  .increase-page-content {
    height: 35.125rem;
  }
}
</style>

<style lang="scss" scoped>
.the-email-resend {
  color: $primary;
}
.resend-email-link {
  text-decoration: none !important;
  cursor: pointer;
  color: $primary;
}
.contact-us {
  text-decoration: none;
  cursor: pointer !important;
  color: $primary;
}
</style>

<style lang="scss" scoped>
.slide-left {
  -webkit-animation: slide-left 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-left 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes slide-left {
  0% {
    -webkit-transform: translateX(2000px);
    transform: translateX(2000px);
  }
  100% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
}

@-webkit-keyframes slide-left {
  0% {
    -webkit-transform: translateX(2000px);
    transform: translateX(2000px);
  }
  100% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
}

</style>
